import React from 'react';
import type { IconComponentProps } from '@/types/components';

export const CheckCircleSolid: React.FC<IconComponentProps> = ({
  className,
}) => (
  <svg
    className={className}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.00181942 8.02186C-0.0884835 3.76647 3.19396 0.322537 7.33642 -0.00894188C11.9447 -0.377721 15.8184 3.08557 15.9937 7.50283C16.165 11.83 12.8345 15.2644 8.76514 15.6413C4.13354 16.0703 0.138707 12.5718 0.00181942 8.02186ZM7.00854 8.61831C6.92218 8.53984 6.8781 8.50219 6.83653 8.46137C6.43626 8.06796 6.03778 7.67314 5.63643 7.28114C5.26411 6.91728 4.72516 6.89969 4.37327 7.23715C4.01636 7.57954 4.02567 8.1211 4.39979 8.49093C5.02151 9.10533 5.64468 9.71832 6.26999 10.3292C6.73834 10.7867 7.2153 10.7828 7.68402 10.3225C8.9737 9.05606 10.2634 7.78962 11.5523 6.52282C11.6072 6.46898 11.6627 6.41514 11.71 6.35532C11.9791 6.01504 11.9501 5.54034 11.6437 5.2342C11.2865 4.87703 10.7525 4.88337 10.3705 5.25742C9.29406 6.31133 8.2201 7.36735 7.14722 8.42442C7.09346 8.47721 7.05763 8.54864 7.00854 8.61831Z"
      fill="currentColor"
    />
  </svg>
);
